<template>
  <div class="modal-backdrop">
    <div class="modal">
      <div class="content">
        <div class="pull-right">
          <div class="btn-close" @click="close"></div>
        </div>
        <h1>Wert Speichern</h1>
        <div class="tab">
          <h3>Als neuer Wert in der Zeitreihe:</h3>
          <select>
            <option value="saab">Beispiel-Lastgang</option>
            <option value="saab">Bepreisungshistorie</option>
            <option value="saab">Terminpreishistorie</option>
            <option value="saab">Temperaturhistorie</option>
          </select>
          <button class="btn-green" @click="close">Speichern</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddValue',
  data() {
    return {};
  },
  props: {
    task: Object,
  },
  methods: {
    close: function () {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 600px;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.tab {
  text-align: left;
  border-top: 1px solid #eaecf1;
  background: #f9f9fb;
  padding: 20px 50px;
  height: 190px;
}

input,
select {
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-right: 10px;
  margin-bottom: 15px;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 24px;
  font-weight: 300;
}

select {
  width: 70%;
}

.date {
  width: 53%;
}

.time {
  width: 33%;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: hidden;
}

button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 25px;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  display: inline-block;
  width: 100%;
}

.imput-group > input {
  width: 40%;
  margin: 0px 20px 20px 0px;
}

.input-group > button {
  min-width: 0;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin-right: 44px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

.modal ul.tabsLabels a.datetime {
  padding: 21px 7px 22px 0px;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .datetime {
}

.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .alert {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -546px -1110px;
}

p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
</style>
